


















































import Vue from 'vue';
import * as api from '@/api';
import { ElForm } from 'element-ui/types/form';

export default Vue.extend({
    props: {
        visible: {
            type: Boolean,
            required: true,
        },
         onlyBindPhone: { type: Boolean },
    },
    data() {
        // const self: any = this;
        const validatePhone = (rule, value, callback) => {
            if (!value.match(/^1[3-9]\d{9}$/)) {
                callback('手机号格式错误');
            }
            callback();
        };
        const validateCode = (rule, value, callback) => {
            if (!value) {
                callback('请输入验证码');
            } else if (!value.match(/^[0-9]{6}$/)) {
                callback('验证码格式错误');
            }
            callback();
        };
        return {
            bindForm: {
                name: '',
                phoneNumber: '',
                verificationCode: '',
            },
            bindRules: {
                name: [
                     { required: true, message: '请输入姓名', trigger: 'blur' },
                    ],
                phoneNumber: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { validator: validatePhone, trigger: 'blur' },
                ],
                verificationCode: [
                    { validator: validateCode, trigger: 'blur' },
                ],
            },
             bindRulesExceptPhone: {
                phoneNumber: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { validator: validatePhone, trigger: 'blur' },
                ],
                verificationCode: [
                    { validator: validateCode, trigger: 'blur' },
                ],
            },
            smsCountDown: 0,
        };
    },
    methods: {
        close() {
            this.$store.commit('loginVisible', false);
            this.$store.commit('bindVisible', false);
            this.$store.dispatch('fetchUserInfoToCheckPhone', localStorage.getItem('token'));
        },
        async bind() {
            console.log(this.bindForm);
            const valid = await (this.$refs.bind as ElForm).validate();
            if (!valid) return;
            const res = await api.bindPhone({ phoneNumber: this.bindForm.phoneNumber, captcha: this.bindForm.verificationCode });
             if (!api.error(res)) {
                // this.$message.success('账户绑定成功');
                this.$emit('close');
                this.close();
            } else {
                this.$message.error(res.error.message);
            }
            if (this.onlyBindPhone) {
                const res1 = await api.editUserInfo({ nickName: this.bindForm.name });

            if (!api.error(res1)) {
                this.close();
            } else {
                this.$message.error(res1.error.message);
            }
            }
        },
        sendVerificationCode() {
            // todo: 连续点多次，会触发多条短信吗？
            (this.$refs.bind as ElForm).validateField('phoneNumber', async (err) => {
                if (err) return;
                const res = await api.sendSMSCaptcha({
                    phoneNumber: this.bindForm.phoneNumber,
                });
                if (!api.error(res)) {
                    this.smsCountDown = 60;
                    const timer = setInterval(() => {
                        this.smsCountDown -= 1;
                        if (this.smsCountDown === 0) {
                            clearInterval(timer);
                        }
                    }, 1000);
                } else {
                    this.$message({
                        type: 'error',
                        message: res.error.message,
                    });
                }
            });
        },
    },
});
